// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mgDmV4cduRsScOePjkiZ{gap:40px;display:flex}.fQtKwn9KygoXjYBM0NO5{position:relative}.VIdHo8L2CzIluJGDm9E9{z-index:1;flex-direction:column;justify-content:center;align-items:center;gap:1px;padding:20px;display:flex;position:absolute;top:0;bottom:0;left:0;right:0}.d_IJavd_hT4S0iKfnVwx{color:var(--content-primary-primary)}.gQUUORkgkG0pvmrXyCbY{align-items:center;gap:5px;display:flex}.rvDZQ1an6uwicwbT17ud{color:var(--content-primary-tertiary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `mgDmV4cduRsScOePjkiZ`,
	"char": `fQtKwn9KygoXjYBM0NO5`,
	"charLabel": `VIdHo8L2CzIluJGDm9E9`,
	"charLabel__title": `d_IJavd_hT4S0iKfnVwx`,
	"charLabelTitle": `d_IJavd_hT4S0iKfnVwx`,
	"charLabel__wrapDesc": `gQUUORkgkG0pvmrXyCbY`,
	"charLabelWrapDesc": `gQUUORkgkG0pvmrXyCbY`,
	"charLabel__desc": `rvDZQ1an6uwicwbT17ud`,
	"charLabelDesc": `rvDZQ1an6uwicwbT17ud`
};
export default ___CSS_LOADER_EXPORT___;
